// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608072034/js/" + chunkId + "." + {"44":"970268f5","225":"aabef7bb","481":"3319638c","486":"8ce07b66","770":"e4da9c88"}[chunkId] + ".0.7208560990814772.chunk.js";
};